
define('ldsh!modules/editor/templates/elements_tree_children', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!isRoot) { ;
__p += '\n  ';
 if (hasChildren) { ;
__p += '\n  <b class="ed-icon ed-tree-action ed-tree-drop"></b>\n  ';
 } ;
__p += '\n\n  ';
 if (!isFormItem) { ;
__p += '\n    <b class="ed-icon ed-tree-action ed-tree-show"></b>\n  ';
 } ;
__p += '\n\n  <span class="ed-tree-t">\n    ';
 if (isFormItem) { ;
__p += '\n      ' +
((__t = ( type )) == null ? '' : __t) +
'\n    ';
 } else { ;
__p += '\n      <b>' +
((__t = ( type )) == null ? '' : __t) +
'</b> ' +
((__t = ( id )) == null ? '' : __t) +
'\n    ';
 } ;
__p += '\n  </span>\n';
 } ;
__p += '\n\n';
 if (hasChildren) { ;
__p += '\n<ul class="ed-tree-list"></ul>\n';
 } ;
__p += '\n';

}
return __p
};});

